// Neurological subsection questionnaire constants
export enum NeurologicalQuestionnaireItem {
  MEDICAL_BACKGROUND_NEURO = 'medical-background/neuro',
  MEDICAL_BACKGROUND_NEURO_HEADACHES = 'medical-background/neuro/headaches',
  MEDICAL_BACKGROUND_NEURO_HEADACHE_TYPE = 'medical-background/neuro/headache-type',
  MEDICAL_BACKGROUND_NEURO_SEIZURES = 'medical-background/neuro/seizures',
  MEDICAL_BACKGROUND_NEURO_SEIZURE_DATE = 'medical-background/neuro/seizure-date',
  MEDICAL_BACKGROUND_NEURO_SEIZURE_TYPE = 'medical-background/neuro/seizure-type',
  MEDICAL_BACKGROUND_NEURO_SEIZURE_PRECAUTIONS = 'medical-background/neuro/seizure-precautions',
  MEDICAL_BACKGROUND_NEURO_NEURO_STATUS = 'medical-background/neuro/neuro-status',
  MEDICAL_BACKGROUND_NEURO_ALTERED_AFFECT = 'medical-background/neuro/altered-affect',
  MEDICAL_BACKGROUND_NEURO_ALTERED_AFFECT_FACTORS = 'medical-background/neuro/altered-affect-factors',
  MEDICAL_BACKGROUND_NEURO_PHQ2_SCREENING = 'medical-background/neuro/phq2-screening',
  MEDICAL_BACKGROUND_NEURO_PHQ2_NOTES = 'medical-background/neuro/phq2-notes',
  MEDICAL_BACKGROUND_NEURO_INTEREST = 'medical-background/neuro/interest',
  MEDICAL_BACKGROUND_NEURO_DEPRESSED = 'medical-background/neuro/depressed',
  MEDICAL_BACKGROUND_NEURO_CAREGIVER_DIFFICULTY = 'medical-background/neuro/caregiver-difficulty',
  MEDICAL_BACKGROUND_NEURO_SYSTEM_SUMMARY = 'medical-background/neuro/system-summary'
}
